define('views/blocks/DateTimeSelectorView',['underscore','backbone','jquery','app',
    'TagCommander',
    'models/EstimatedTimeModel',
    'template!blocks/datetime-selector',
    'template!blocks/times-selector',
    'template!blocks/times-now',
    'template!blocks/times-default',
    'moment',
    'momentFormats',
    'moment-round',
    'datetimePicker'
],
    function (_,backbone,$,app,
        TagCommander,
        EstimatedTimeModel,
        dateTimeSelectorTemplate,
        timesSelectorTemplate,
        timesNowTemplate,
        timesDefaultTemplate,
        moment,
        momentFormats
    ) {

    return backbone.View.extend({
        events:{
            'submit form':'submitForm',
            'click .submit':'submitForm',
            'change [name=datetime]':'selectDate',
            'click .btn-close':'clickClose',
            'change [name=period]':'onPeriodChange',
            'click button.time':'onTimeSelect'
        },
        period: 'am',
        initialize:function(options){
            var view = this;

            _.extend(view, options);

            // on utilise le panier en option, ou par défault, le panier courant
            var cart = view.cart;
            if(!cart){
                cart = view.cart = app.getCart();
            }

            view.setMoment(cart.getDatetimeMoment());
            view.isNow = cart.isNow(),
            view.isVAE = cart.isVAE(),
            view.store = cart.getStore();
            if(!view.store){
                // si il n'y a pas de boutique, on essaie d'en trouver une, ça n'est pas normal
                setTimeout(function(){cart.requireDeliveryOptions('all',true,function(){
                   view.initialize(options);
                })},100);
                return;
            }
            view.minDate = moment(new Date()).startOf('day');
            view.maxDate = view.minDate.clone().add(parseInt(app.c('_DIFFER_MAX_WEEKS_',5)),'w');
            if(view.preorder_product){
                view.initPreorder();
            }else{
                view.isNow = cart.isNow() && view.isNowAvailable();
                view.isAm = cart.isAm();
                view.period = view.isNow ? 'now' : view.isAm ? 'am':'pm';
            }

            if(_.isUndefined(arguments.el)){
                this.render();
            }
            this.listenTo(cart,'deliveryUpdate',this.onDeliveryUpdate);
            view.listenTo(cart,'setDeliveryOptionsFail',view.onSubmitFail);
        },
        initPreorder:function(){
            var view = this,
                preorder_product = view.preorder_product,
                daysOfWeekDisabled = [],
                minDate = view.minDate,
                maxDate = view.maxDate,
                product_visibility = preorder_product.get('visibility'),
                cartMomentDay,
                cartDate = new Date();

            var from = preorder_product.get('from'),
                to = preorder_product.get('to');

            // from = from ? from.replace(/-/g,'/') : false;
            // to = to ? to.replace(/-/g,'/') : false;
            if(from){
                from = moment(from).startOf('day');
                if(from.diff(minDate) > 0){
                    view.minDate = cartDate = from;
                    view.datetime = from.toDate();
                }
            }
            if(to){
                to = moment(to).startOf('day')
                if(maxDate.diff(to) > 0){
                    view.maxDate    = to;
                }
            }

            cartMomentDay = moment(cartDate).format('YYYY/MM/DD ')

            view.product_visibility = _(product_visibility).map(function(day_visibility){
                var dayFrom = moment(cartMomentDay+day_visibility.from),
                    dayTo = moment(cartMomentDay+day_visibility.to),
                    daySwitch = moment(cartMomentDay+'16:00:00'),
                    dayDiff = dayTo.diff(dayFrom) / 60000, // in minute
                    isWeekDayEnable = dayDiff>=1,
                    am=dayFrom.isBefore(daySwitch),
                    pm=dayTo.isAfter(daySwitch)
                ;
                if(!isWeekDayEnable){
                    daysOfWeekDisabled.push(day_visibility.day);
                }
                return _.extend(day_visibility,{
                    enabled:isWeekDayEnable,
                    am:am,
                    pm:pm,
                    hMin:dayFrom.hour(),
                    mMin:dayFrom.minute(),
                    hMax:dayTo.hour(),
                    mMax:dayTo.minute(),
                });
            });

            view.daysOfWeekDisabled = daysOfWeekDisabled;
            view.setMoment(moment(view.datetime));

            view.isAm =
            view.isNow =
            view.period =
            view.minutes =
            view.hours = false;
        },
        setMoment:function(m){
            var view = this,
                daysOfWeekDisabled = view.daysOfWeekDisabled;

            if(daysOfWeekDisabled){
                if(daysOfWeekDisabled.length<7) { // prevent full week disabled
                    while (!!(daysOfWeekDisabled.indexOf(m.day())+1)) {
                        m.add(1, 'd')
                    }
                }
                view.daysOfWeekDisabled = daysOfWeekDisabled;
            }

            view.datetime = new Date(m);

            // TODO gérer la notion de period pour le switch AM/PM
            view.date = m.format('DD');
            view.month = m.format('MM');
            view.year = m.format('YYYY');
            view.hours = m.format('HH');
            view.minutes = m.format('mm');
        },
        setup:function(){

        },
        render:function(){
            var view = this;

            // refresh times values
            if(view.isNow){
                view.getEstimatedTime();
            }else if(view.period){
                view.getTimes();
            }else{
                view.times = false;
            }

            view.$el.html(dateTimeSelectorTemplate(view));

            var preorder_product = view.preorder_product,
                datepickerOptions = {
                inline: true,
                minDate: view.minDate,
                maxDate: view.maxDate,
                locale:app.c('_MOMENT_JS_LOCALE_',false),
                defaultDate: view.datetime,
            };

            if(preorder_product){
                datepickerOptions['daysOfWeekDisabled'] = view.daysOfWeekDisabled;
            }

            view.updateRender();

            function loadDatetimePicker(){
                var datetimepicker;
                try {
                    datetimepicker = view.$('.datepicker').datetimepicker(datepickerOptions);
                    datetimepicker.on('dp.change',function(e){
                        view.onDayChange(e);
                        view.$('.picker-switch').on('click',function(e){e.stopPropagation()});
                    });
                    view.$('.picker-switch').on('click',function(e){e.stopPropagation()});
                }catch (e) {
                    delete datepickerOptions.defaultDate;
                    loadDatetimePicker();
                }
            }
            setTimeout(loadDatetimePicker, 1);
        },
        formatMoment:function(format){
            return moment(this.datetime).format(format);
        },
        formatDate:function(){
            return this.formatMoment('YYYY/MM/DD');
        },
        formatTime:function(){
            return this.formatMoment('HH:mm:ss');
        },
        getLabel:function(type,usePreorderVariant){
            var view = this, options = [],
                preorder_product = view.preorder_product;
            if(usePreorderVariant && preorder_product){
                options = [preorder_product.getName()];
                switch(type){
                    case 'valider':
                        type = 'Précommander';
                        break;
                    default:
                        type += '_preorder';
                        break;
                }
            }
            return app.t(type,'DatetimeSelector',options);
        },
        updateRender:function(ignoreAmPm, ignoreTimeSelector){
            var view = this;

            if(ignoreAmPm !== true){
                view.$('.moment #am').attr('disabled',!view.isPeriodAvailable('am'));
                view.$('.moment #pm').attr('disabled',!view.isPeriodAvailable('pm'));
            }


            if(ignoreTimeSelector !== true){
                var template = '';
                if(view.period === false){
                    template = timesDefaultTemplate()
                }else if(view.isNow){
                    view.getEstimatedTime();
                    template = timesNowTemplate(view)
                }else{
                    view.getTimes();
                    template = timesSelectorTemplate(view);
                }
                view.$('.times-selector').html(template);
            }

            view.$('.target-date-label').html(view.formatLabel());

            view.$('[name=period]').each(function(index,radio){
                $(radio).attr('checked',radio.value==view.period);
            });

            var checkNow = view.$('.check-group.now');
            checkNow.toggle(view.isToday());
            checkNow.find('input').attr('disabled',!view.isNowAvailable());


            view.$('[type=date]').val(moment(view.datetime).format('YYYY/MM/DD'));
            view.$('[type=time]').val(moment(view.datetime).format('HH:mm:ss'));
            view.$('.submit').toggleClass('hidden',!view.isDatetimeValid());

        },
        getStore:function(){
            var view = this;
            return view[view.period+'Store'] || view.store;
        },
        formatLabel:function(){
            var view = this, label;

            if(view.isDatetimeValid()){
                label = app.t(view.isVAE ? 'À venir chercher %s':'Livraison prévue %s', 'DatetimeSelector', view.formatedMoment())
            }else{
                label = app.t('Veuillez selectionner une date et un horaire valide','DatetimeSelector');
            }
            return label;
        },
        formatedMoment:function(){
            var view = this;
            return view.isNow ? app.t('maintenant','DatetimeSelector') : moment(view.datetime).calendar(new Date(),momentFormats.getFormats())
        },
        isToday:function(){
              return moment(this.datetime).startOf('day').diff(moment().startOf('day')) === 0;
        },
        isNowAvailable:function(){
            // on vérifie que la boutique livre "maintenant"
            // et qu'on a selectionné aujourd’hui
              var cart = this.cart,
                  isNowAvailable = this.isToday()
                  && cart.getStore().isAvailableNow(cart.isVAE());
            return isNowAvailable;
        },
        getProductVisibilityOfDay:function(){
            var product_visibility = this.product_visibility,
                day = moment(this.datetime).isoWeekday();
            return _(product_visibility).find(function(day_visibility){
                return day_visibility.day === day;
            });
        },
        isPeriodAvailable:function(period){
            // détermine si un période est disponible ou pas
            var view = this,
                product_visibility = view.getProductVisibilityOfDay(),
                cart = view.cart,
                datetime = view.datetime,
                isVAE = view.isVAE,
                available = view.store.isPeriodAvailable(isVAE,period,datetime);

            if(product_visibility && product_visibility[period] === false){
                return false;
            }

            if(!isVAE){
                // en livraison
                // on affecte les périodes à des boutiques,
                // si en livraison on cherche la plage de disponibilité dans toutes les boutiques
                var stores = app.getStores().findByPostcode({
                    id_postcode:cart.getPostcodeId(),
                    id_district:cart.getDistrictId(),
                    isVAE:isVAE,
                },datetime), store = stores.shift();

                if(store && stores.length==0){
                    // si il y a une seule boutique sur la plage horaire
                    view[period+'Store'] = store;
                    available = store.isPeriodAvailable(isVAE,period,datetime);
                }else{
                }
                //
            }else{
                view[period+'Store'] = view.store;
            }
            return available;
        },
        isUnavailableDatetime:function(){
            var view = this,
                store = view.getStore(),
                availableDatetime = store.findAvailableDatetime(view.isVAE,view.datetime);
            return availableDatetime.closed || availableDatetime.diff!=0;
        },
        isDatetimeValid:function(){
            var view = this,
                a = !view.isUnavailableDatetime(),
                m = view.minutes !== false,
                h = view.hours !== false;
            return (view.period == 'now') || a & m & h ;
        },
        onDayChange:function(e){
            var view = this, datetime = view.datetime, newDate = moment(e.date.toDate());
            datetime.setDate(1); // prevent 31 / 30 month switching bug
            datetime.setYear(view.year=newDate.year());
            datetime.setMonth(view.month = newDate.month());
            datetime.setDate(view.date = newDate.date());
            view.isNow = view.isToday() && view.isNowAvailable();
            view.period =
            view.hours =
            view.minutes = false;
            view.updateRender();
            app.scrollTop(view.$('.block-moment').offset().top, 300);
        },
        submitForm:function(e){
            e.preventDefault();
            e.stopPropagation();
            var view = this,
                cart = view.cart;
            function onFail(e){
                view.toggleLoadingButton(false);
            }
            view.toggleLoadingButton(true);
            try {
                var store = view.getStore(),
                    availableDatetime = store.findAvailableDatetime(view.isVAE, view.datetime);
                if (availableDatetime.closed) return app.error();
                //
                var moment = availableDatetime.moment,
                    date = moment.format('YYYY-MM-DD'),
                    time = moment.format('HH:mm:ss'),
                    now = view.isNow ? 1 : availableDatetime.now
                ;
                //
                // tracking
                TagCommander.tc_ev_gl(view.el,'eventGA',{
                    click_level1:'Commander',
                    click_level2:(cart.isVAE()?'À emporter':'Livraison')+' '+(now?'maintenant':'différée'),
                    click_level3:moment.format()
                });
                //
                if (store != view.store || !!view.preorder_product) {
                    // store change
                    var deliveryOptions = _(cart.getDeliveryOptions()).pick('description', 'place_id', 'id_store', 'latitude', 'longitude'),
                        options = cart.pick('id_address_delivery', 'place_id', 'id_district', 'id_postcode', 'postcode'),
                        vae = cart.isVAE () ? 1 : 0;
                    options.postcode = cart.getPostcode();
                    options.vae = vae;
                    options.now = now;
                    options.order_date = date
                    options.order_time = time
                    if(!!vae){
                        options.id_store = store.id;
                        deliveryOptions.id_store = store.id;
                    }else{
                        var latitude = deliveryOptions.latitude,
                            longitude = deliveryOptions.longitude,
                            ignore_geo_validation = !latitude && !longitude ? 1 : 0;
                        options.ignore_geo_validation =ignore_geo_validation;
                        if(!ignore_geo_validation){
                            options.latitude = latitude;
                            options.longitude = longitude;
                        }
                    }
                    cart.setDeliveryOptions(options, deliveryOptions, moment.toDate()).fail(onFail);
                    return;
                }
                // store unchanged
                cart.setDeliveryDatetime(date, time, now).fail(onFail);
            }catch(err){
                app.error();
            }
        },
        onSubmitFail: function(){
            // on réactive le bouton de soumission
          this.toggleLoadingButton(false);
        },
        toggleLoadingButton: function(disabled){
            this.$('.submit').toggleClass('loading',disabled).attr('disabled',disabled);
            this.$('fieldset').attr('disabled',disabled);
        },
        onDeliveryUpdate:function(cart){
            var view = this,
                product = view.preorder_product;

            function addProductDone(){
                complete(true);
            }
            function addProductFail(){
                complete(false);
            }
            function complete(success){
                view.trigger('complete',view,success);
                view.clickClose();
            }
            if(view.preorder_add_product){

                cart.addProduct(product.id,1)
                    .fail(addProductFail)
                    .done(addProductDone);

            }else if(view.preorder_display_product){
                complete(true);
                app.go('product', {product: product});
            }else{
                complete(true);
            }
        },
        clickClose:function(){
            this.trigger('close',this);
        },
        getTimes: function(){
            var view = this,
                product_visibility = view.getProductVisibilityOfDay(),
                // si une période est selectionnée, et que le store existe, on le set
                store = view.getStore();
            var times = view.times = store.getTimes(view.isVAE,view.datetime,view.isAm);
            if(product_visibility){
                times.forEach(function (t) {
                    var is_before_visibility_max = (t.h<=product_visibility.hMax) && (t.m<=product_visibility.mMax),
                        is_after_visibility_min = (t.h>product_visibility.hMin) || (t.h===product_visibility.hMin && t.m>=product_visibility.mhMin);
                    t.isAvailable = t.isAvailable && is_before_visibility_max && is_after_visibility_min;
                })
            }
            return times;
        },
        onPeriodChange: function(e){
            var view = this, val = $(e.currentTarget).val();
            view.period = val;
            view.isNow = val == 'now';
            view.hours =
            view.minutes = false;
            view.isAm = view.isNow ?
                        (new Date()).getHours()<16 : // avant 16h00
                        (val == 'am') // ;
            view.updateRender();
            app.scrollTop(view.$('.times-selector').offset().top, 300);
        },
        onTimeSelect:function(e){
            e.preventDefault();
            e.stopPropagation();
            var view = this,
                target = e.currentTarget,
                time = target.dataset,
                hours = view.hours = parseInt(time.h),
                minutes = view.minutes = parseInt(time.m)
                ;
            view.datetime.setHours(hours);
            view.datetime.setMinutes(minutes);
            view.updateRender(true,true);
            view.$('.time').removeClass('active');
            view.$(target).addClass('active');
            app.scrollTop(view.$('.block-moment').offset().top, 300);
        },
        getEstimatedTime:function () {
            var view = this,
                cart = view.cart,
                estimatedTime = view.estimatedTime;
            if(!estimatedTime){
                estimatedTime = view.estimatedTime = new EstimatedTimeModel({
                    id_store:cart.getStore().id,
                    id_postcode:cart.getPostcodeId()
                });
                view.listenTo(estimatedTime,'change',view.onEstimatedTimeChange);
                estimatedTime.fetch();
            }
            return estimatedTime;
        },
        onEstimatedTimeChange:function(estimatedTime){
            var view = this;
            if(view.isNow){
                view.$('.block-times').html(timesNowTemplate(view))
            }
        }
    });
});

